import { render, staticRenderFns } from "./HorizontalTable.vue?vue&type=template&id=76d4417b&"
import script from "./HorizontalTable.vue?vue&type=script&lang=js&"
export * from "./HorizontalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports